var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAuth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -11.000000000000046 960 876",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2310,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M960 427c0 44.7-36.2 80.9-80.9 80.9H600L480 265.2 609.5 40.9C631.9 2.2 681.3-11 720 11.3c38.7 22.4 51.9 71.8 29.6 110.5L620.1 346.1h259c44.7 0 80.9 36.2 80.9 80.9z",
    fill: "#1a73e8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M720 842.7c-38.7 22.3-88.1 9.1-110.5-29.6L480 588.8 350.5 813.1c-22.4 38.7-71.8 51.9-110.5 29.6-38.7-22.4-51.9-71.8-29.6-110.5l129.5-224.3 140.1-5.3 140.1 5.3 129.5 224.3c22.3 38.7 9.1 88.1-29.6 110.5z",
    fill: "#ea4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M480 265.2l-36.5 99.2-103.6-18.3-129.5-224.3c-22.3-38.7-9.1-88.1 29.6-110.5 38.7-22.3 88.1-9.1 110.5 29.6z",
    fill: "#fbbc04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M459.1 346.1l-93.9 161.8H80.9C36.2 507.9 0 471.7 0 427s36.2-80.9 80.9-80.9z",
    fill: "#34a853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M620.1 507.9H339.9L480 265.2z",
    fill: "#185db7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAuth);
export default __webpack_public_path__ + "static/media/GoogleAuth.f92b813a25f8abd558ea298aa2c3f15b.svg";
export { ForwardRef as ReactComponent };